import script from "./left-top.vue?vue&type=script&setup=true&lang=ts"
export * from "./left-top.vue?vue&type=script&setup=true&lang=ts"

import "./left-top.vue?vue&type=style&index=0&id=02e48b47&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e48b47"]])

export default __exports__